import { FunctionComponent, MouseEventHandler } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { RotatingIconButton } from '../RotatingIconButton/RotatingIconButton';
import { RotationType } from '../RotatingIconButton/RotatingIconButton.interface';
import { IToggleExpandButtonProps } from './ToggleExpandButton.interface';

export const ToggleExpandButton: FunctionComponent<IToggleExpandButtonProps> = (props) => {
  const {
    isExpanded,
    onChange,
    color = 'inherit',
    size = 'small',
    sx,
    rotationType = RotationType.Quarter,
  } = props;

  const handleExpandClick: MouseEventHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onChange?.(!isExpanded);
  };

  return (
    <RotatingIconButton
      reverse={isExpanded}
      rotatingMode={'rotate'}
      rotationType={rotationType}
      size={size}
      color={color}
      onClick={handleExpandClick}
      aria-expanded={isExpanded}
      aria-label={'show more'}
      sx={sx}
    >
      <ChevronRightIcon />
    </RotatingIconButton>
  );
};
